export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["min"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comprare"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["per"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivo"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Link dell’annuncio"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID maker"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descrizione"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Timeout"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data di creazione"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagherò"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Riceverò"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limite dell'operazione"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tutti"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Operazioni"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID offerta"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tasso"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona conto"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fuori limite"])}
}